const TOPICS = [
  { name: "#直播翻车现场#", heat: 982, size: "lg" },
  { name: "#综艺名场面合集#", heat: 760, size: "md" },
  { name: "#调解节目金句#", heat: 1204, size: "xl" },
  { name: "#剧集彩蛋伏笔#", heat: 640, size: "md" },
  { name: "#逐帧鉴伪大赛#", heat: 845, size: "lg" },
  { name: "#声明逐句核实#", heat: 553, size: "md" },
  { name: "#热搜词退烧记#", heat: 402, size: "sm" },
  { name: "#围观现场表情包#", heat: 688, size: "lg" },
  { name: "#舆论风向复盘#", heat: 511, size: "sm" },
  { name: "#瓜田第一现场#", heat: 1308, size: "xl" },
  { name: "#舞台幕后考古#", heat: 356, size: "sm" },
  { name: "#名字冲榜啦#", heat: 470, size: "md" },
  { name: "#一瓜多吃#", heat: 294, size: "sm" },
  { name: "#三分钟看完#", heat: 372, size: "sm" },
];

const SIZE: Record<string, string> = {
  xl: "text-base md:text-lg px-5 py-2.5",
  lg: "text-sm md:text-[15px] px-4 py-2",
  md: "text-sm px-3.5 py-1.5",
  sm: "text-[12px] px-3 py-1.5",
};

export default function Topics() {
  return (
    <section id="topics" className="border-t border-background-200/70 bg-background-100/60 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="rounded-3xl overflow-hidden bg-background-50 border border-background-200/70 p-6 md:p-8">
          <div className="flex items-center justify-between flex-wrap gap-3">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-xl bg-accent-500 text-background-50 flex items-center justify-center">
                <i className="ri-price-tag-3-fill" aria-hidden="true"></i>
              </span>
              <div>
                <h2 className="font-display font-black text-foreground-950 text-2xl md:text-3xl">话题广场</h2>
                <p className="text-xs text-foreground-500 mt-1">点开任意话题，钻进对应的瓜田围观现场</p>
              </div>
            </div>
            <span className="flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-radio-button-line text-primary-500" aria-hidden="true"></i>
              实时热度 · 每小时刷新
            </span>
          </div>

          <div className="flex flex-wrap items-center gap-2.5 md:gap-3 mt-6 md:mt-7">
            {TOPICS.map((t) => {
              const hot = t.heat > 800;
              const extra = hot ? "bg-accent-500 text-background-50" : "bg-background-100 text-foreground-700 border border-background-200/70 hover:border-accent-300";
              return (
                <a
                  key={t.name}
                  href="#discuss"
                  className={`inline-flex items-center gap-2 rounded-full ${SIZE[t.size]} font-semibold whitespace-nowrap transition-all hover:-translate-y-0.5 cursor-pointer ${extra}`}
                >
                  <i className={hot ? "ri-fire-fill" : "ri-price-tag-3-line"} aria-hidden="true"></i>
                  {t.name}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}